import {OperatorId, getOperatorById, FormatCallback} from './Operators';

const formatOperatorQuery = (
  operatorId: OperatorId,
  options: Parameters<FormatCallback>[0]
): ReturnType<FormatCallback> => {
  const operator = getOperatorById(operatorId);

  const {name: operatorName} = operator;

  switch (operator.id) {
    case '==':
    case '!=':
    case '>=':
    case '<=':
      return operator.format(options);

    case '>':
    case '<':
      return {operatorName, value: options.value ?? ''};

    case 'idin':
      return {
        operatorName: 'idin',
        value: options.value ?? '',
      };

    case 'idnin':
      return {
        operatorName: 'idnin',
        value: options.value ?? '',
      };

    case 'exists':
    case 'notexists':
    case 'true':
    case 'false':
    default:
      return {operatorName, value: operator.value};
  }
};

export const mapFieldsQuery = (
  operator: OperatorId,
  value: string | number | null,
  value2: string | number | null,
  value3: string | number | null,
  fieldType: string
) => {
  const options = {
    value,
    value2,
    value3,
    type: fieldType,
  } as const;
  return formatOperatorQuery(operator, options);
};

export type {OperatorId};

export {
  OPERATOR_EQ,
  OPERATOR_NE,
  OPERATOR_GT,
  OPERATOR_LT,
  OPERATOR_GTE,
  OPERATOR_LTE,
  OPERATOR_EXISTS,
  OPERATOR_NOT_EXISTS,
  OPERATOR_IDIN,
  OPERATOR_IDNIN,
  OPERATOR_TRUE,
  OPERATOR_FALSE,
  isComparisonOperator,
  getOperatorsByName,
  getOperatorById,
} from './Operators';

export type {OperatorType} from './Operators';

export function isRawFilterObj(
  obj: unknown
): obj is {fieldPath: string; operatorName: string; value: unknown} {
  return Boolean(
    obj &&
    typeof obj === 'object' &&
    'fieldPath' in obj &&
    typeof obj.fieldPath === 'string' &&
    'operatorName' in obj &&
    typeof obj.operatorName === 'string' &&
    'value' in obj
  );
}
